import { Node as PmNode } from 'prosemirror-model'
import { DecorationSet } from 'prosemirror-view'

import type { DocumentRanges } from '#choo-app/lib/editor/plugins/act-slug-tracker'
import { BlockFormats } from '#util/formats'
import { PageLayout } from '#util/PageLayout'

import { extractBlockInfo } from './helpers'
import { PaginationBreakdown as PaginationBreakdownImpl } from './PaginationBreakdown'

export const createPaginationBreakdown = ({
  doc,
  blockFormats,
  pageLayout,
  documentRanges,
  splitPoints,
}: {
  doc: PmNode
  blockFormats: BlockFormats
  pageLayout: PageLayout
  documentRanges?: DocumentRanges
  splitPoints?: DecorationSet
}) => {
  const { pageBlocks, titlePageBlocks } = extractBlockInfo({
    doc,
    blockFormats,
  })

  return new PaginationBreakdownImpl({
    blocks: pageBlocks,
    titlePageBlocks: titlePageBlocks,
    maxLines: pageLayout.maxLinesPerPage,
    documentRanges,
    splitPoints,
  })
}

export type PaginationBreakdown = ReturnType<typeof createPaginationBreakdown>

export interface PageCounts {
  pageCount: number
  titlePageCount: number
}
